module.exports = __webpack_public_path__ + "static/media/59.35d4678e.gif";